// TelcoTrack — the one toast host. Bottom-right on every page.
// Portaled to document.body so the shell overflow and the map cannot clip it.

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { ToastItem, ToastService, TT_TOAST_MOTION_MS } from './toast.service';

@Component({
  selector: 'app-toast-host',
  templateUrl: './toast-host.component.html',
  styleUrls: ['./toast-host.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHostComponent implements AfterViewInit, OnDestroy {
  readonly items$ = this.toast.items$;

  private movedToBody = false;
  private originalParent: HTMLElement | null = null;
  private originalNextSibling: ChildNode | null = null;

  constructor(
    private readonly toast: ToastService,
    private readonly elRef: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.elRef.nativeElement, '--tt-toast-motion', `${TT_TOAST_MOTION_MS}ms`);
    this.moveToBody();
  }

  ngOnDestroy(): void {
    this.moveBack();
  }

  trackById(_index: number, item: ToastItem): number {
    return item.id;
  }

  dismiss(id: number): void {
    this.toast.dismiss(id);
  }

  private moveToBody(): void {
    if (typeof document === 'undefined' || !document.body) return;
    const host = this.elRef.nativeElement;
    if (host.parentElement === document.body) return;
    this.originalParent = host.parentElement;
    this.originalNextSibling = host.nextSibling;
    this.renderer.appendChild(document.body, host);
    this.movedToBody = true;
  }

  private moveBack(): void {
    if (!this.movedToBody || !this.originalParent) return;
    if (this.originalNextSibling && this.originalParent.contains(this.originalNextSibling)) {
      this.renderer.insertBefore(this.originalParent, this.elRef.nativeElement, this.originalNextSibling);
    } else {
      this.renderer.appendChild(this.originalParent, this.elRef.nativeElement);
    }
    this.movedToBody = false;
    this.originalParent = null;
    this.originalNextSibling = null;
  }
}
